import React, { Component } from "react";
import { css } from "emotion";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ScrollLock from "react-scrolllock";
import { close, copy } from "../../state/actions/shareActions";
import { connect } from "react-redux";
import Button from "../global/Button";
import { max } from "../../utils/CssUtils";

const icClose = require("../../assets/ic_close.svg");
const icFacebook = require("../../assets/share/facebook.svg");
const icTwitter = require("../../assets/share/twitter.svg");
const icLinkedIn = require("../../assets/share/linked-in.svg");

const shareBox = css({
  maxWidth: 480,
  height: 250,
  width: "95vw",
  background: "white",
  borderRadius: 4,
  position: "absolute",
  top: "calc(50% - 125px)",
  left: "calc(50% - 240px)",
  [max(480)]: {
    left: "2.5vw"
  }
});

const header = css({
  borderBottom: "1px solid #dedede",
  textAlign: "center",
  padding: 14,
  position: "relative",
  marginBottom: 40,
  button: {
    position: "absolute",
    top: 16,
    right: 16,
    width: 24,
    height: 24,
    background: "#fff",
    backgroundImage: `url(${icClose})`,
    border: "none"
  }
});

const socialButtonWrapper = css({
  width: 190,
  margin: "0 auto",
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 40
});

const socialButton = css({
  width: 50,
  height: 50,
  border: "none",
  background: "#fff",
  ":hover": {
    cursor: "pointer"
  }
});

const inputWrapper = css({
  padding: "0 14px",
  display: "flex",
  input: {
    height: 36,
    paddingLeft: 12,
    fontSize: 16,
    border: "1px solid #8D949E",
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    width: "100%"
  },
  button: {
    borderTopLeftRadius: "0px !important",
    borderBottomLeftRadius: "0px !important"
  },
  [max(600)]: {
    input: {
      height: 32
    }
  }
});

class Share extends Component {
  constructor() {
    super();
  }

  closeModal = () => {
    const { close } = this.props;
    close();
  };

  render() {
    const { share, copy } = this.props;
    const faddedBackdrop = css({
      position: "fixed",
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 99999999999
    });
    if (!share.open) {
      return;
    }
    return (
      <div className={faddedBackdrop}>
        <ScrollLock />
        <div className={shareBox}>
          <div className={header}>
            <h2>Share</h2>
            <button onClick={this.closeModal} />
          </div>
          <div className={socialButtonWrapper}>
            <button
              className={socialButton}
              style={{ backgroundImage: `url(${icFacebook})` }}
              onClick={() =>
                window.open(
                  `http://www.facebook.com/sharer.php?u=${share.link}`,
                  "_blank"
                )
              }
              aria-label="Share - Facebook"
            />
            <button
              className={socialButton}
              style={{ backgroundImage: `url(${icTwitter})` }}
              onClick={() =>
                window.open(
                  `https://twitter.com/share?url=${share.link}&amp;hashtags=humanitix`,
                  "_blank"
                )
              }
              aria-label="Share - Twitter"
            />
            <button
              className={socialButton}
              style={{ backgroundImage: `url(${icLinkedIn})` }}
              onClick={() =>
                window.open(
                  `https://www.linkedin.com/sharing/share-offsite/?url=${share.link}`,
                  "_blank"
                )
              }
              aria-label="Share - Linked In"
            />
          </div>
          <div class={inputWrapper}>
            <input value={share.link} />
            <CopyToClipboard text={share.link} onCopy={copy}>
              <Button>Copy</Button>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => ({
    share: state.share
  }),
  {
    close,
    copy
  }
)(Share);
